import { lazy } from "react";
import { CiMonitor } from "react-icons/ci";
import { BankOutlined, DollarOutlined } from "@ant-design/icons";

const Companies = lazy(() => import("../pages/auth/Internal/Companies"));
const CommingSoon = lazy(() => import("../pages/other/coming_soon"));
const Subscription = lazy(() => import("../pages/auth/Internal/Subscriptions"));

export const MENU_LIST_INTERNAL = [
  {
    name: "Dashboard",
    code: "Dashboard",
    icon: <CiMonitor />,
    path: "/dashboard",
    element: <CommingSoon />,
  },
  {
    name: "Companies",
    code: "Companies",
    icon: <BankOutlined />,
    path: "/companies",
    element: <Companies />,
  },
  {
    name: "Subscription",
    code: "Subscription",
    icon: <DollarOutlined />,
    path: "/subscription",
    element: <Subscription />,
  },
];
